// D24 A3 — som + aviso flutuante quando a LIA passa um ticket para atendimento (transbordo). Spec docs/ticket-detail-2027/02-design/
// d24-v01.md §3.A3 + delta d24-v02.md §3 + d24-v03.md §2/§3 (o delta mais novo prevalece). Chamado SÓ pelo FilaAbas.receberEvento,
// com o LiaTicketEvent action 'lia-handoff' (o mesmo caminho do Echo e do gancho de teste tkFila.receberEvento).
//
// - O aviso é ACRÉSCIMO: o enfileiramento da sincronização continua no FilaAbas, igual.
// - Som: o <audio id="audio-notification"> do header (fica fora do @if do sino, D24 B). No máximo 1 play() a cada 5 s (rajada).
//   O toast NÃO espera o play(). 3ª linha ("som bloqueado") SÓ com NotAllowedError (v02 §3): AbortError (pause()/load() de outro
//   chamador do mesmo <audio>, v03 §3), outro erro ou promessa pendente → sem 3ª linha.
// - Toast: Notyf 3.10 global (vendor-hw.js), tipo próprio 'tk-transbordo' com className 'tk-toast' (a pele mora em _fila.scss, sempre com
//   .tk-toast no seletor: o container do dashboard LIA não é tocado). 10 s de vida, ×, pilha de no máximo 3 (o mais antigo sai).
//   Aba do navegador escondida: o som toca na hora e o toast espera o visibilitychange para visible.
// - Mensagem = TEXTO com '\n' (white-space: pre-line). O Notyf põe a mensagem por innerHTML e anuncia o options.message como texto:
//   os textos são escapados antes (& < > "). A 3ª linha que chega depois entra como nó de texto, nunca por innerHTML.

const SOM_JANELA_MS = 5000;
const TOAST_MS = 10000;
const PILHA_MAX = 3;

const AvisoTransbordo = function () {

    let T = {};
    let anunciar = () => {};
    let notyf = null;
    let ultimoSom = -Infinity;
    const pendentes = [];   // avisos que esperam a aba voltar (aba escondida)
    const abertos = [];     // { notif, node } na ordem de abertura

    const t = (k, p) => String(T[k] || k).replace(/:([a-z]+)/g, (m, c) => (p && c in p ? String(p[c]) : m));
    const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    const escondida = () => document.visibilityState === 'hidden';

    const instancia = () => {
        if (notyf) return notyf;
        if (typeof window.Notyf !== 'function') return null;   // sem o vendor-hw.js: só o som
        notyf = new window.Notyf({
            duration: TOAST_MS,
            ripple: false,
            dismissible: true,
            position: { x: 'right', y: 'bottom' },
            // Sem background: o Notyf só pinta fundo inline quando o tipo tem um (a pele vem da folha).
            types: [{ type: 'tk-transbordo', className: 'tk-toast', icon: { className: 'ai ai-clock-3h tk-toast-ico', tagName: 'i' } }],
        });
        return notyf;
    };

    // Toast ainda na tela (o Notyf marca --disappear antes do animationend que o remove).
    const vivo = (a) => !!a.node && a.node.isConnected && !a.node.classList.contains('notyf__toast--disappear');

    // ---------- som ----------
    // Dentro da janela de 5 s não há play() (logo, nunca 3ª linha). A rejeição do play() chega depois e marca o aviso.
    const tocar = (aviso) => {
        const audio = document.getElementById('audio-notification');
        const agora = performance.now();
        if (!audio || typeof audio.play !== 'function' || agora - ultimoSom < SOM_JANELA_MS) return;
        ultimoSom = agora;
        let p;
        try {
            audio.currentTime = 0;
            p = audio.play();
        } catch (e) {
            return;   // navegador sem mídia: sem som e sem aviso falso
        }
        if (p && typeof p.catch === 'function') {
            p.catch((err) => {
                if (!err || err.name !== 'NotAllowedError') return;   // AbortError / outro erro: tocou ou foi trocado, nunca "bloqueado"
                aviso.bloqueado = true;
                if (aviso.node && vivo(aviso)) {
                    const msg = aviso.node.querySelector('.notyf__message');
                    if (msg) msg.appendChild(document.createTextNode('\n' + t('toast_som')));
                    anunciar(t('toast_som'));   // o anunciador do Notyf já falou as 2 primeiras linhas
                }
                // Sem toast ainda (aba escondida): ele nasce com a 3ª linha.
            });
        }
    };

    // ---------- toast ----------
    const abrir = (aviso) => {
        const n = instancia();
        if (!n) return;
        for (let i = abertos.length - 1; i >= 0; i--) { if (!vivo(abertos[i])) abertos.splice(i, 1); }
        while (abertos.length >= PILHA_MAX) {
            const velho = abertos.shift();
            try { n.dismiss(velho.notif); } catch (e) { /* já saiu */ }
        }
        const linhas = [t('toast_tit'), t('toast_txt', { id: aviso.id })];
        if (aviso.bloqueado) linhas.push(t('toast_som'));
        const notif = n.open({ type: 'tk-transbordo', message: linhas.map(esc).join('\n') });
        // O _renderNotification anexa o toast no fim do container, de forma síncrona.
        const nos = document.querySelectorAll('.notyf__toast.tk-toast');
        const node = nos.length ? nos[nos.length - 1] : null;
        aviso.node = node;
        if (node) {
            const x = node.querySelector('.notyf__dismiss-btn');
            if (x) { x.setAttribute('type', 'button'); x.setAttribute('aria-label', t('toast_fechar')); }
        }
        abertos.push({ notif, node });
    };

    const aoVoltar = () => {
        if (escondida() || !pendentes.length) return;
        pendentes.splice(0, pendentes.length).forEach(abrir);
    };

    return {
        // textos = data-textos do #tk-fila (toast_tit, toast_txt, toast_som, toast_fechar); fala = anunciar() da fila.
        init: function (textos, fala) {
            T = textos || {};
            if (typeof fala === 'function') anunciar = fala;
            document.addEventListener('visibilitychange', aoVoltar);
        },
        avisar: function (id) {
            const aviso = { id: id, bloqueado: false, node: null };
            tocar(aviso);   // o som toca na hora, mesmo com a aba escondida
            if (escondida()) pendentes.push(aviso); else abrir(aviso);
        },
    };
}();

module.exports = AvisoTransbordo;
